import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
// Data Tables
// import jQuery from "jquery";
// import "datatables.net-bs4";
// import "datatables.net-buttons-bs4";
// import "datatables.net-buttons/js/buttons.html5";
// import "datatables.net-buttons/js/buttons.print";
// import "datatables.net-buttons/js/buttons.flash";
// import "pdfmake/build/pdfmake";
// import "pdfmake/build/vfs_fonts";

import Loader from "components/Custom/Loader";
import AutoComplete from "components/Custom/AutoComplete";
import TxtBox from "components/Custom/TxtBox";
import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";

import { NOTIFY, DEFAULTS } from "common/config";
import { LABELS, ERRORS, WARNINGS, SUCCESS, CONFIRMS } from "common/labels";
import { DateFunctions } from "common//datefunctions";
import { COMMON_JS } from "common/scripts";
import { ApiReports } from "apihandlers//reports";
import { ApiMasters } from "apihandlers//masters/masters";
const ApiReportsHandler = new ApiReports();
const ApiMastersHandler = new ApiMasters();

// const $ = jQuery;

const BrokerLedger = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [chartData, setChartData] = useState<any>({});
  const [masters, setMasters] = useState<any>([]);
  const [rows, setRows] = useState<any>(null);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [exportName, setExportName] = useState("");

  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "broker",
      name: LABELS.BROKER,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "indentNo",
      name: LABELS.INDENT_NO,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "vehicleNo",
      name: LABELS.VEHICLE_NO,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "driverUsername",
      name: LABELS.USER_NAME,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "paymentMadeOn",
      name: LABELS.PAYMENT_DATE,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "enteredDate",
      name: LABELS.ENTERED_DATE,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "paymentAmount",
      name: LABELS.PAYMENT_AMOUNT,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
      renderSum: true,
    },
    {
      key: "chargeType",
      name: LABELS.CHARGE_TYPE,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "chargesCategoryName",
      name: LABELS.CHARGE_CATEGORY,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "9",
      name: LABELS.PAYMENT_TYPE,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "paymntType",
      name: LABELS.FUEL_QUANTITY,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
      renderSum: true,
    },
    {
      key: "remarks",
      name: LABELS.REMARKS,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "isPayment",
      name: LABELS.IS_PAYMENT,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "activeStatus",
      name: LABELS.ACTIVE,
      width: "6%",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
    },
  ];
  useEffect(() => {
    if (loading) {
      getMasterData();
    }
  }, [loading]);

  const getMasterData = () => {
    const args = { minResponse: true };
    ApiMastersHandler.getTransporters(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list: any = [{ id: -1, label: "All" }];
        let recs: any = response.records;
        for (let i = 0; i < recs.length; i++) {
          list.push({
            id: recs[i].id,
            label: recs[i].organizationName,
          });
        }
        setMasters(list);
        setLoading(false);
      }
    });
  };

  const loadChart = () => {
    const id = masterRef.current.selectedValue.id;
    if (!id) {
      COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.DATA_IS_EMPTY);
      return;
    }
    const broker = masterRef.current.selectedValue.label;
    const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
      .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
    setExportName(
      LABELS.BROKER +
        ":" +
        broker +
        "\n" +
        LABELS.FROM_DATE +
        ":" +
        fromDt +
        "\n" +
        LABELS.TO_DATE +
        ":" +
        toDt
    );
    const args = {
      fromDt,
      toDt,
      // id: -1,
      // vehicleId: -1,
      reportType: "excel",
    };

    setChartData(null);
    ApiReportsHandler.getBrokerLedger(args).then((res) => {
      // console.log("getUserLogReport:", args);
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        const list = response.rows;
        for (let i = 0; i < response.rows.length; i++) {
          response.rows[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatus"] = "Yes";
          } else {
            list[i]["activeStatus"] = "No";
          }
        }
        setChartData(response);
        setRows(response.rows);
      }
    });
  };

  const masterRef: any = useRef();

  // console.log("elist:", masters);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => props.setDashMenu(LABELS.HOME)}>
            {LABELS.REPORTS}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{LABELS.BROKER_LEDGER_REPORT}</li>
        </ul>
        <h4>{LABELS.BROKER_LEDGER_REPORT}</h4>
      </div>
      {loading ? (
        <div className="flexCenter" style={{ minHeight: 450 }}>
          <Loader />
        </div>
      ) : (
        <div className="hChart">
          <div
            style={{ width: "100%", display: "flex", flexDirection: "column" }}
          >
            <div
              className="formGroup"
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: 5,
                marginBottom: 10,
                width: "40%",
              }}
            >
              <label>{"Select Broker :"}</label>
              <AutoComplete
                id={"masters"}
                list={masters}
                childRef={masterRef}
                defaultValue={{ id: -1, label: "All" }}
              />
            </div>
            <div
              className="formGroup"
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: 0,
                marginBottom: 20,
              }}
            >
              <div
                style={{
                  display: "flex",
                  marginRight: 15,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label
                  style={{
                    fontWeight: "500",
                    fontSize: 14,
                    marginTop: 6,
                    marginRight: 8,
                  }}
                >
                  {LABELS.FROM_DATE}
                </label>
                <TxtBox
                  type={"date"}
                  id="fromDt"
                  defaultValue={DateFunctions.getDate(
                    "today",
                    "from",
                    "YYYY-MM-DD"
                  )}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  marginRight: 15,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label
                  style={{
                    fontWeight: "500",
                    fontSize: 14,
                    marginTop: 6,
                    marginRight: 8,
                  }}
                >
                  {LABELS.TO_DATE}
                </label>
                <TxtBox
                  type={"date"}
                  id="toDt"
                  defaultValue={DateFunctions.getDate(
                    "thismonth",
                    "to",
                    "YYYY-MM-DD"
                  )}
                />
              </div>

              <div
                style={{
                  display: "flex",
                }}
              >
                <Btn
                  text={LABELS.LOAD}
                  onClick={loadChart}
                  // loading={!chartData}
                />
              </div>
            </div>
          </div>
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          {rows && (
            <ExcelGrid
              id={"brokerLedgerReport"}
              title={LABELS.BROKER_LEDGER_REPORT}
              height={window.innerHeight * 0.8}
              cols={columns}
              rows={rows}
              exportOption={true}
              newRowOption={false}
              exportName={exportName}
              //onReload={reloadGrid}
              // onAdd={onAdd}
            />
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(BrokerLedger);
